import React from 'react';
import { SectionWrapper } from '../Investigate.styles';
import {
	Title,
	Header,
	ButtonWrapper,
	LoadingContainer,
	TableWrapper,
	NoData,
} from './CommonVendors.styles';
import { CHART_COLORS, EXPORT_OPTIONS, makeUnknownFromEmpty } from '../utils';
import { CommonVendorsChart } from './CommonVendorsChart';
import CommonVendorsTableContainer from './CommonVendorsTable';
import { getFormattedSpendWithSymbol } from 'utils/number';
import {
	getInvestigateTopCommonVendors,
	exportInvestigateCommonVendorsData,
	exportInvestigateTopCommonVendors,
} from 'utils/apiRequests';
import {
	ApLoaderDefault,
	ApLoaderText,
	ApButtonIcon,
	ApMenu,
	ApMenuItem,
} from '@alixpartners/ui-components';
import isEqual from 'lodash/isEqual';
import { SettingsContext } from 'contexts/SettingsContext';

export class CommonVendors extends React.Component {
	state = { chartData: null, isLoading: false };
	chartRef = React.createRef();

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		const { queryParams } = this.props;

		if (!isEqual(queryParams, prevProps.queryParams)) {
			this.fetchData();
		}
	}

	fetchData = () => {
		const { queryParams } = this.props;

		this.setState({ isLoading: true });

		getInvestigateTopCommonVendors(queryParams).then(chartData => {
			this.setState({ chartData, isLoading: false });
		});
	};

	getSeriesData = () => {
		const { chartData } = this.state;

		if (!chartData || chartData.length === 0) {
			return [];
		}

		const seriesMap = chartData[0].spendSplit;

		return seriesMap.map(({ name }, index) => {
			return {
				name,
				color: CHART_COLORS[index],
				data: chartData.map(item => {
					const current = item.spendSplit.find(i => i.name === name) || {};

					return {
						y: current.spend || 0,
						value: current.spend || 0,
						name: makeUnknownFromEmpty(current.name),
						percentage: current.percentage,
					};
				}),
			};
		});
	};

	getCategories = () => {
		const { chartData } = this.state;

		if (!chartData || chartData.length === 0) {
			return [];
		}
		return chartData.map(({ vendorName }) => vendorName);
	};

	spendFormatter = (value, withZero) => {
		const { currencySymbol, hideDecimals } = this.props;

		return value || withZero
			? getFormattedSpendWithSymbol(value, currencySymbol, hideDecimals).toUpperCase()
			: '-';
	};

	getChartInstance = () => {
		return (
			this.chartRef && this.chartRef.current && this.chartRef.current.chart
		);
	};

	handleChartExport = option => {
		const chartInstance = this.getChartInstance();

		if (chartInstance && option.value === 'png') {
			chartInstance.exportChart(
				{
					filename: 'SXR-Top_10_common-vendors',
				},
				{
					chart: { width: 1200 },
				}
			);
		}

		if (option.value === 'xlsx') {
			this.handleChartDataExport();
		}
	};

	handleChartDataExport = () => {
		const {
			onDownloadStart,
			onDownloadSuccess,
			onDownloadError,
			queryParams,
		} = this.props;

		onDownloadStart();
		exportInvestigateTopCommonVendors(queryParams)
			.catch(onDownloadError)
			.finally(onDownloadSuccess);
	};

	handleTableDataExport = () => {
		const {
			onDownloadStart,
			onDownloadSuccess,
			onDownloadError,
			queryParams,
		} = this.props;

		onDownloadStart();
		exportInvestigateCommonVendorsData(queryParams)
			.catch(onDownloadError)
			.finally(onDownloadSuccess);
	};

	render() {
		const { cardTitle, queryParams, showExplorePage, spendType } = this.props;
		const { chartData, isLoading } = this.state;

		return (
			<SectionWrapper>
				<Header>
					<Title>{cardTitle}</Title>
					{chartData &&
						(chartData.length > 0 &&
							!isLoading && (
								<ButtonWrapper>
									<ApMenu button={<ApButtonIcon iconName="download" />}>
										{EXPORT_OPTIONS.map(option => (
											<ApMenuItem
												key={option.value}
												onClick={() => this.handleChartExport(option)}
											>
												{option.label}
											</ApMenuItem>
										))}
									</ApMenu>
								</ButtonWrapper>
							))}
				</Header>
				{!chartData ? (
					<LoadingContainer>
						<ApLoaderDefault loaderText={() => <ApLoaderText />} />
					</LoadingContainer>
				) : chartData.length === 0 && !isLoading ? (
					<NoData>No data available</NoData>
				) : (
					<CommonVendorsChart
						isLoading={isLoading}
						spendFormatter={this.spendFormatter}
						series={this.getSeriesData()}
						categories={this.getCategories()}
						chartRef={this.chartRef}
					/>
				)}

				{chartData &&
					chartData.length > 0 && (
						<TableWrapper>
							<Header>
								<ButtonWrapper>
									<ApMenu button={<ApButtonIcon iconName="download" />}>
										<ApMenuItem onClick={this.handleTableDataExport}>
											{EXPORT_OPTIONS[1].label}
										</ApMenuItem>
									</ApMenu>
								</ButtonWrapper>
							</Header>

							<CommonVendorsTableContainer
								queryParams={queryParams}
								spendFormatter={this.spendFormatter}
								showExplorePage={showExplorePage}
								spendType={spendType}
							/>
						</TableWrapper>
					)}
			</SectionWrapper>
		);
	}
}

export default props => (
	<SettingsContext.Consumer>
		{({ hideDecimals }) => (
			<CommonVendors
				{...props}
				hideDecimals={hideDecimals}
			/>
		)}
	</SettingsContext.Consumer>
);
